import { fbt } from 'fbtee'
import { Heart } from 'lucide-react'
import { useCoarsePointer } from '@/hooks/useCoarsePointer'
import { GoingCheckIcon } from './GoingCheckIcon'

export function GoingTipBody() {
  const coarse = useCoarsePointer()
  return (
    <span className="flex flex-col gap-0.5">
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
        <span>
          {fbt(
            'Interested',
            'First line of the Going coachmark; followed by a heart icon to associate with the heart on the card',
          )}
        </span>
        <Heart className="size-3.5 fill-interested text-interested shrink-0" />
      </span>
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
        <span>
          {coarse
            ? fbt(
                'Tap to switch to Going',
                'Second line of the Going coachmark on touch devices; followed by the same checkmark icon shown on the card when the user is going',
              )
            : fbt(
                'Click to switch to Going',
                'Second line of the Going coachmark on desktop; followed by the same checkmark icon shown on the card when the user is going',
              )}
        </span>
        <GoingCheckIcon className="size-3.5 shrink-0" />
      </span>
    </span>
  )
}
